export { default } from './InputLabel';